<template>
  <div class="color-picker-wrapper w-full" ref="wrapper">
    <input :disabled="disabled" @click="togglePicker" class="w-full" v-model="color" style="border-radius: 5px; border:1px solid rgba(0,0,0,.2); padding: 10px; padding-left: 36px;"/>
    <div @click="togglePicker" class="preview" :style="{
      backgroundImage: 'url(' + require('@/assets/images/transparent.png') + ')',
      backgroundRepeat: 'repeat',
      backgroundSize: '47px 45px',
    }"></div>
    <div @click="togglePicker" class="preview" :style="{ backgroundColor: color }"></div>
    <div v-if="showPicker" ref="popover" class="picker-popover">
      <chrome-picker :value="color" @input="updateColor" />
    </div>
  </div>
</template>

<script>
import { Chrome } from "vue-color";

export default {
  name: "ColorPicker",
  components: { "chrome-picker": Chrome },
  props:{
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.color = newVal;
      },
    },
  },
  data() {
    return {
      color: "",
      showPicker: false,
    };
  },
  methods: {
    togglePicker() {
      if (this.disabled) return;

      this.showPicker = !this.showPicker;

      if (this.showPicker) {
        this.$nextTick(() => {
          this.adjustPosition();
        });
      }
    },
    updateColor(newColor) {
      // hsla 객체가 있으면 hsla 문자열로 변환
      if (newColor.hsl) {
        const { a } = newColor.hsl;
        const alphaHex = Math.round(a * 255)
          .toString(16)
          .padStart(2, "0"); // 0~255 → 2자리 hex
        this.color = `${newColor.hex}${alphaHex}`;
      } else {
        this.color = newColor.hex;
      }
      this.$emit("input", this.color);
    },
    handleClickOutside(event) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(event.target)) {
        this.showPicker = false;
      }
    },
    adjustPosition() {
      const wrapperRect = this.$refs.wrapper.getBoundingClientRect();
      const popover = this.$refs.popover;
      const popoverRect = popover.getBoundingClientRect();
      const margin = 10;

      // 기본: preview 왼쪽, bottom 맞춤
      let left = wrapperRect.left - popoverRect.width - 4; // 왼쪽으로 위치
      let top = wrapperRect.bottom - popoverRect.height; // 하단 정렬

      // 화면 왼쪽으로 넘어가면 wrapper 왼쪽 기준으로 조정
      if (left < margin) {
        left = wrapperRect.left;
      }

      // 화면 위로 넘어가면 top 최소 0
      if (top < margin) {
        top = margin;
      }

      // 화면 오른쪽으로 넘어가면 조정
      if (left + popoverRect.width > window.innerWidth) {
        left = window.innerWidth - popoverRect.width - margin;
      }

      // 화면 아래로 넘어가면 조정
      if (top + popoverRect.height > window.innerHeight) {
        top = window.innerHeight - popoverRect.height - margin;
      }

      popover.style.position = "fixed";
      popover.style.top = `${top}px`;
      popover.style.left = `${left}px`;
      popover.style.zIndex = 1000;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.color-picker-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.preview {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 22px;
  height: 22px;
  border-radius: 4px;
}

.code {
  font-family: monospace;
  font-size: 14px;
}

.picker-popover {
  /* 위치는 JS에서 처리 */
}
</style>
